module.exports = __webpack_public_path__ + "img/aiimage4.dd9c1f23.jpg";